import { render, staticRenderFns } from "./PendingApproval.vue?vue&type=template&id=41d76d16&scoped=true&"
import script from "./PendingApproval.vue?vue&type=script&lang=js&"
export * from "./PendingApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d76d16",
  null
  
)

export default component.exports